// Redeem form

export function formRedeem() {
  document.querySelectorAll('.form-redeem-voucher').forEach(el => {
    const input = el.querySelector('.input-redeem-quantity')
    const plusButton = el.querySelector('.plus')
    const minusButton = el.querySelector('.minus')
    const max = parseInt(input.getAttribute('max'))
  
    const verifyValueButton = val => {
      if (val >= max) {
        plusButton.classList.add('disabled')
        plusButton.classList.add('text-muted')
      } else {
        plusButton.classList.remove('disabled')
        plusButton.classList.remove('text-muted')
      }
      if (val <= 1) {
        minusButton.classList.add('disabled')
        minusButton.classList.add('text-muted')
      } else {
        minusButton.classList.remove('disabled')
        minusButton.classList.remove('text-muted')
      }
    }
  
    input.addEventListener('keypress', e => {
      const val = parseInt(e.currentTarget.value)
      if (val >= max) {
        e.preventDefault()
        e.stopPropagation()
      }
      verifyValueButton(val)
    })
  
    plusButton.addEventListener('click', e => {
      e.stopPropagation()
      e.preventDefault()
      const val = parseInt(input.value)

      if (val >= max) {
        return false
      }
      input.value = val + 1
      input.dispatchEvent(new Event('change'))
      verifyValueButton(parseInt(input.value))
    })

    minusButton.addEventListener('click', e => {
      e.stopPropagation()
      e.preventDefault()
      const val = parseInt(input.value)

      if (val > 1) {
        input.value = val - 1
        input.dispatchEvent(new Event('change'))
      }
  
      verifyValueButton(parseInt(input.value))
    })
  
    verifyValueButton(parseInt(input.value))
  })
}

document.addEventListener('turbo:load', function() {
  formRedeem()
})
